<template>
  <TsCard appendClass="shadow-md text-center p-4 m-0 bg-[#fafafa] flex lg:flex-col items-center justify-between gap-4"
    type="vertical">
    <TsImage height="64" width="120" class="w-full rounded-xl max-lg:max-w-[120px]" :src="props.image" :alt="props.alt" loading="lazy"/>
    <NuxtLink class="lg:inline-block lg:w-full" :to="link" :target="props.shouldOpenInNewTab ? '_blank' : '_self'"
      :data-testid="`guarantee-registration-link-to-${props.link}`">
      <TsButton append-class="whitespace-nowrap" :label="props.buttonCta" :block="!isMobile" :size="isMobile ? 'sm' : 'md'" />
    </NuxtLink>
  </TsCard>
</template>

<script setup lang="ts">
const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

const { isMobile } = useDevice();

type Props = {
  image?: string;
  alt?: string;
  link?: string;
  buttonCta?: string;
  shouldOpenInNewTab?: string;
};

const props = withDefaults(defineProps<Props>(), {});
</script>
